export const getTruncatedEmail = (email: string, length: number = 12) => {
  const separatorIndex = email.indexOf('@');

  let emaiLocalPart = separatorIndex !== -1 ? email.slice(0, separatorIndex) : email;
  const emailDomainPart = separatorIndex !== -1 ? email.slice(separatorIndex + 1) : '';

  emaiLocalPart = emaiLocalPart.length > length ? emaiLocalPart.substring(0, length) + '...' : emaiLocalPart;

  return `${emaiLocalPart}@${emailDomainPart}`;
};
